import { render, staticRenderFns } from "./ShipmentMain.vue?vue&type=template&id=a91f4976&scoped=true"
import script from "./ShipmentMain.vue?vue&type=script&lang=js"
export * from "./ShipmentMain.vue?vue&type=script&lang=js"
import style0 from "./ShipmentMain.vue?vue&type=style&index=0&id=a91f4976&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a91f4976",
  null
  
)

export default component.exports